var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin":"5%"}},[_c('b-button',{attrs:{"size":"sm","variant":"outline-primary"},on:{"click":_vm.cleanAllErrors}},[_vm._v("Effacer tout")]),_vm._v(" "),_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.items}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06470c5e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/errors.vue
// module id = null
// module chunks = 